<ng-container *ngIf="filterOptions.length; else noSupportedOperators">
  <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="center center">
    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Text Filter</mat-label>
      <mat-select [(ngModel)]="newValue.parameter">
        <mat-option
          *ngFor="let option of filterOptions | rdsSortTextParameterOption"
          [value]="option"
          [disabled]="!enabledOptions[option.type]"
          >{{ option?.label }}</mat-option
        >
      </mat-select>
      <mat-hint>{{ newValue?.parameter?.type | rdsFilterOperatorHint }}</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Text</mat-label>
      <input matInput i18n-placeholder placeholder="Text" [formControl]="inputControl" type="text" />
      <mat-error *ngIf="inputControl.errors" i18n>Text input must be provided.</mat-error>
    </mat-form-field>

    <button
      mat-mini-fab
      class="add-filter-button"
      i18n-aria-label
      aria-label="Add filter"
      color="accent"
      i18n-matTooltip
      matTooltip="Add filter"
      matTooltipShowDelay="250"
      [disabled]="!newValue.parameter"
      (click)="handleAdd()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <rds-c-chips
    [chips]="filters | rdsTextFiltersToChips"
    [dense]="false"
    [removable]="true"
    (removed)="handleRemove($event)"
    [vertical]="true"
  ></rds-c-chips>
</ng-container>
<ng-template #noSupportedOperators>
  <p i18n>No filter operations are supported for this data product.</p>
</ng-template>
